export const DECISION_CHOICES_MIN = 2;
export const DECISION_CHOICES_MAX = 3;
export const COUNTDOWN_SECONDS_VALUES = [5, 8, 10, 15];
export const DEFAULT_COUNTDOWN_SECONDS = 8;
